module.exports = __webpack_public_path__ + "img/refreshing-arrows-couple.429492fd.svg";